import { WearablesEntity } from "./wearables.entities";
import { calculateParticipantRowMetrics, calculateRowMetrics, dialogMetricColumnDefs, EmptyMetric, metricColumnDefs } from "./wearables.functions";

export class WearablesSitesTab {

    wearablesData: WearablesEntity[];

    tableSelector: string;
    table: any;

    dialogTable: any;

    constructor(tableSelector: string, wearablesData: WearablesEntity[]) {
        this.tableSelector = tableSelector;
        this.wearablesData = wearablesData;
    }

    initializeTable() {
        this.table = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: [
                // { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                // { data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap trial-col' },
                // { data:'siteName', title: 'Site', className: 'text-left font-size12 site-col' },
                { data:'siteDisplay', title: 'Site', className: 'text-left font-size12 nowrap site-col' },
                { data:'totalParticipants', title: 'Total<br>Participants', className: 'text-center font-size12 nowrap last-fixed' },
                ...metricColumnDefs,
            ]
        });

        $(this.tableSelector).on('click', 'tr', this, function (evt) {
            const row = $(evt.data.tableSelector).DataTable().row(this).data();
            evt.data.showDialog(row.trials, row.siteId, row.siteName);
        });

        this.initializeDialog();
    }

    updateData(filter) {
        if (!filter) return;

        const rows = [];

        filter.selectedSiteIds.forEach((sid) => {

            const group = this.wearablesData.filter((w) => (filter.selectedAppendixIds.includes(w.AppendixId) && (w.SiteNumber === sid)));
            if (group.length > 0) {

                const metrics = calculateRowMetrics(group);

                const site = filter.sites.find((s) => s.Id === sid);
                rows.push({
                    trials: filter.selectedAppendixIds,
                    siteName: site.Name,
                    siteDisplay: `<span class="site-display" title="${site.Name}">${String(sid).padStart(3,'0')}</span>` ,
                    siteId: sid,
                    ...metrics,
                });
            }

        });

        rows.sort((a, b) => a.siteId - b.siteId).sort((a, b) => a.trialId - b.trialId);

        this.table.clear();
        this.table.rows.add(rows).draw();
    }

    refresh() {
        this.table.draw();
    }

    initializeDialog() {
        this.dialogTable = $('#dialog-site-details-table').DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 3
            },
            columns: [
                // { data:'platform', title: 'Platform', className: 'text-left font-size12 nowrap' },
                { data:'trial', title: 'Trial', className: 'text-left font-size12 nowrap' },
                { data:'participantId', title: 'Participant', className: 'text-center font-size12 nowrap' },
                ...dialogMetricColumnDefs
            ]
        });

        $('#site-details-modal').on('shown.bs.modal', () => {
            this.dialogTable.draw();
        });
    }

    showDialog(appendices: number[], siteId: number, siteName: string) {

        const participants = this.wearablesData
            .filter((w) => (appendices.includes(w.AppendixId) && (w.SiteNumber === siteId)))
            .map((p) => calculateParticipantRowMetrics(p));

        this.dialogTable.clear();
        this.dialogTable.rows.add(participants).draw();

        $('#site-details-modal-title').text(`${siteName}`);
        $('#site-details-modal').modal('show');
    }

}